import { GridModel } from '@/models';
export class PostbackErrorLogViewModel  extends GridModel {
    constructor() {
        super();
    }
    public get headers() {
        return [
            {
                text: 'URL',
                align: 'left',
                sortable: false,
                value: 'requestId'
            },
            {
                text: 'Remote IP',
                align: 'left',
                sortable: false,
                value: 'ngbid'
            },
            {
                text: 'User Agent',
                align: 'left',
                sortable: false,
                value: ''
            },
            {
                text: 'Status',
                align: 'left',
                sortable: false,
                value: 'stateTime'
            },
            {
                text: 'Content Type',
                align: 'left',
                sortable: false,
                value: 'endTime'
            },
            {
                text: 'Timestamp',
                align: 'left',
                sortable: false,
                value: 'lastName'
            }
        ];
    }
}